export default "__VITE_ASSET__CET83Ctp__"